<img
  *ngIf="condition"
  src="../../../assets/icons/alert.svg"
  alt="Alert"
  class="alert-icon"
/>
